import { Body, Controller, NotFoundException, Post, Get, Query, ForbiddenException } from '@nestjs/common'
import { CRMMessageDto, CRMMessageDtoAttachmentDto, FacebookDataDto } from '@decet/sistema-mensajes-shared'
import { WebhookAplicacionService } from '../../../../plataforma/services/aplicacion.server.services'
import { WebhookListenerService, WebhookMensajeDto } from '../../../services/listener.server.services'
import { WebhookTipoMensajeService } from '../../../services/tipo-mensaje.server.services'

@Controller('webhook/mensaje/recibido')
export class WebhookMensajeRecibidoController {
  constructor(
    private mensajeRecibido: WebhookListenerService,
    private tipoMensaje: WebhookTipoMensajeService,
    private aplicacionService: WebhookAplicacionService,
  ) {}

  @Post()
  async post(@Body() body) {
    if (body.object !== 'page') {
      throw new NotFoundException({
        error: true,
      })
    }
    const mensajes: WebhookMensajeDto[] = []
    const resultado: CRMMessageDto[] = []
    const tipoMensajes = await this.tipoMensaje.obtenerTipoMensaje('facebook')

    let bodyMessage: FacebookDataDto = null

    for await (const entry of body.entry) {
      bodyMessage = entry.messaging[0]
      const cuenta = await this.aplicacionService.obtenerAplicacion(bodyMessage.recipient.id)

      if (!cuenta) {
        throw new NotFoundException('No existe esa aplicación')
      }
      resultado.push({
        plataforma: {
          id: 1,
          descripcion: 'facebook',
        },
        cuenta: {
          apikey: cuenta.apiKey,
          identificador: cuenta.identificador,
          token: cuenta.token,
        },
        timestamp: new Date(bodyMessage.timestamp),
        message: {
          id: bodyMessage.message.mid,
          text: {
            body: bodyMessage.message.text || '',
          },
          attachments: this.desifrarAttachments(bodyMessage),
        },
        contact: {
          nombre: '',
          identificador: bodyMessage.sender.id,
        },
      })

      this.findAllPropieties(tipoMensajes[0].configuracion, bodyMessage)

      const tipoMensaje = tipoMensajes.find((i) =>
        Object.keys(i.configuracion.message || '').every((keys) =>
          Object.keys(bodyMessage.message).find((item) => item === keys),
        ),
      )

      mensajes.push({
        cuentaId: cuenta.id,
        tipoMensaje: tipoMensaje.nombre,
        mensaje: bodyMessage,
      })
      await this.mensajeRecibido.agregar(cuenta, mensajes, resultado)
    }
    return 'EVENT_RECEIVED'
  }
  @Get()
  async get(@Query() params) {
    let VERIFY_TOKEN = 'FHSK3DMALK3LSDKLLKPAM'
    let mode = params['hub.mode']
    let token = params['hub.verify_token']
    let challenge = params['hub.challenge']

    if (mode && token) {
      if (mode === 'subscribe' && token === VERIFY_TOKEN) {
        return challenge
      } else {
        throw new ForbiddenException({
          error: true,
        })
      }
    }
  }
  desifrarAttachments(data: FacebookDataDto): CRMMessageDtoAttachmentDto[] {
    if (!data.message.attachments) {
      return []
    }
    return data.message.attachments.map((item) => ({
      id: data.message.mid,
      type: item.type,
      url: item.payload.url,
    }))
  }

  findAllPropieties(object, data) {
    for (const key of Object.getOwnPropertyNames(data)) {
      if (typeof object[key] === 'object' && object[key] != undefined && object[key] != null) {
        if (!data[key]) {
          return false
        }
        this.findAllPropieties(object[key], data[key])
      } else {
        if (!object[key]) {
          return false
        }
      }
    }
  }
}
